/* ==========================================================================
   The Wild Daughter — Theme JavaScript
   Handles: sticky header, mobile menu, cart drawer, product gallery,
   quantity selector, collapsible tabs, predictive search, cookie banner
   ========================================================================== */

(function () {
  'use strict';

  /* ---------- Sticky Header ---------- */
  const header = document.querySelector('.header');
  if (header) {
    let lastScroll = 0;
    window.addEventListener('scroll', function () {
      const currentScroll = window.scrollY;
      if (currentScroll > 50) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
      lastScroll = currentScroll;
    }, { passive: true });
  }

  /* ---------- Mobile Menu ---------- */
  const mobileToggle = document.querySelector('[data-mobile-menu-toggle]');
  const mobileMenu = document.querySelector('.mobile-menu');
  const mobileClose = document.querySelector('[data-mobile-menu-close]');
  const mobileOverlay = document.querySelector('#MobileOverlay');

  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    if (mobileOverlay) mobileOverlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    if (mobileOverlay) mobileOverlay.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  if (mobileToggle) mobileToggle.addEventListener('click', openMobileMenu);
  if (mobileClose) mobileClose.addEventListener('click', closeMobileMenu);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileMenu);

  // Mobile submenu toggles
  document.querySelectorAll('[data-mobile-submenu-toggle]').forEach(function (trigger) {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      var submenu = this.nextElementSibling;
      if (submenu) {
        submenu.classList.toggle('is-open');
        this.classList.toggle('is-open');
      }
    });
  });

  /* ---------- Cart Drawer ---------- */
  const cartDrawer = document.getElementById('CartDrawer');
  const cartOverlay = document.getElementById('CartOverlay');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  // Open cart triggers
  document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openCartDrawer();
    });
  });

  // Close cart triggers
  document.querySelectorAll('[data-cart-close]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      if (e.target === btn || e.currentTarget === btn) {
        closeCartDrawer();
      }
    });
  });

  // Intercept add-to-cart forms to open the drawer
  document.querySelectorAll('form[action="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(function (response) { return response.json(); })
        .then(function () {
          // Refresh cart drawer content
          refreshCartDrawer();
          openCartDrawer();
        })
        .catch(function (error) {
          console.error('Add to cart error:', error);
          // Fallback: submit form normally
          form.submit();
        });
    });
  });

  function refreshCartDrawer() {
    fetch('/cart.js')
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        // Reload the cart drawer section
        fetch('/?sections=cart-drawer')
          .then(function (response) { return response.json(); })
          .then(function (sections) {
            var html = sections['cart-drawer'];
            if (html) {
              var temp = document.createElement('div');
              temp.innerHTML = html;
              var newItems = temp.querySelector('#CartDrawerItems');
              var newFooter = temp.querySelector('.cart-drawer__footer');
              var currentItems = document.getElementById('CartDrawerItems');
              var currentFooter = cartDrawer.querySelector('.cart-drawer__footer');

              if (currentItems && newItems) {
                currentItems.innerHTML = newItems.innerHTML;
              }
              if (currentFooter && newFooter) {
                currentFooter.innerHTML = newFooter.innerHTML;
              } else if (!currentFooter && newFooter) {
                cartDrawer.appendChild(newFooter);
              }
            }
          });
      });
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
    var bubble = document.getElementById('cart-count-bubble');
    if (bubble) bubble.textContent = count;
  }

  /* ---------- Product Gallery ---------- */
  var mainImage = document.getElementById('ProductMainImage');
  if (mainImage) {
    document.querySelectorAll('.product-gallery__thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var url = this.getAttribute('data-image-url');
        var alt = this.getAttribute('data-image-alt');
        var img = mainImage.querySelector('img');
        if (img && url) {
          img.src = url;
          img.alt = alt || '';
        }
        // Update active state
        document.querySelectorAll('.product-gallery__thumb').forEach(function (t) {
          t.classList.remove('is-active');
        });
        this.classList.add('is-active');
      });
    });
  }

  /* ---------- Variant Selector ---------- */
  var variantSelect = document.getElementById('ProductVariantSelect');
  if (variantSelect) {
    document.querySelectorAll('.product-variants__option').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var optionIndex = parseInt(this.getAttribute('data-option-index'));
        var optionValue = this.getAttribute('data-option-value');

        // Update active state within this option group
        var parent = this.closest('.product-variants__options');
        parent.querySelectorAll('.product-variants__option').forEach(function (b) {
          b.classList.remove('is-selected');
        });
        this.classList.add('is-selected');

        // Find matching variant
        var selectedOptions = [];
        document.querySelectorAll('.product-variants').forEach(function (group, index) {
          var selected = group.querySelector('.product-variants__option.is-selected');
          if (selected) {
            selectedOptions[index] = selected.getAttribute('data-option-value');
          }
        });

        // Match variant
        for (var i = 0; i < variantSelect.options.length; i++) {
          var option = variantSelect.options[i];
          var title = option.textContent.trim().split(' — ')[0];
          var variantOptions = title.split(' / ');
          var match = true;

          for (var j = 0; j < selectedOptions.length; j++) {
            if (selectedOptions[j] && variantOptions[j] !== selectedOptions[j]) {
              match = false;
              break;
            }
          }

          if (match) {
            variantSelect.value = option.value;
            // Update price display
            var priceEl = document.querySelector('.product-info__price');
            if (priceEl && option.getAttribute('data-price')) {
              priceEl.textContent = option.getAttribute('data-price');
            }
            // Update add to cart button
            var addBtn = document.querySelector('form[action="/cart/add"] [type="submit"]');
            if (addBtn) {
              if (option.disabled) {
                addBtn.disabled = true;
                addBtn.textContent = 'Sold out';
              } else {
                addBtn.disabled = false;
                addBtn.textContent = 'Add to cart';
              }
            }
            break;
          }
        }
      });
    });
  }

  /* ---------- Quantity Selector ---------- */
  document.querySelectorAll('.quantity-selector').forEach(function (selector) {
    var input = selector.querySelector('.quantity-selector__input');
    var decreaseBtn = selector.querySelector('[data-action="decrease"]');
    var increaseBtn = selector.querySelector('[data-action="increase"]');

    if (decreaseBtn) {
      decreaseBtn.addEventListener('click', function () {
        var value = parseInt(input.value) || 1;
        if (value > 1) {
          input.value = value - 1;
        }
      });
    }

    if (increaseBtn) {
      increaseBtn.addEventListener('click', function () {
        var value = parseInt(input.value) || 1;
        input.value = value + 1;
      });
    }
  });

  /* ---------- Collapsible Tabs ---------- */
  document.querySelectorAll('[data-tab]').forEach(function (tab) {
    var trigger = tab.querySelector('.product-tab__trigger');
    if (trigger) {
      trigger.addEventListener('click', function () {
        var isOpen = tab.classList.contains('is-open');
        tab.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', !isOpen);
      });
    }
  });

  /* ---------- Predictive Search ---------- */
  var searchInput = document.querySelector('[data-predictive-search-input]');
  var searchResults = document.querySelector('.predictive-search');

  if (searchInput && searchResults) {
    var debounceTimer;

    searchInput.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      var query = this.value.trim();

      if (query.length < 3) {
        searchResults.classList.remove('is-active');
        searchResults.innerHTML = '';
        return;
      }

      debounceTimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,article,page&resources[limit]=6')
          .then(function (response) { return response.json(); })
          .then(function (data) {
            var html = '';
            var resources = data.resources.results;

            if (resources.products && resources.products.length > 0) {
              resources.products.forEach(function (product) {
                var imgSrc = product.image ? product.image.replace(/(\.\w+)$/, '_100x125$1') : '';
                html += '<a href="' + product.url + '" class="predictive-search__result">';
                if (imgSrc) {
                  html += '<div class="predictive-search__result-image"><img src="' + imgSrc + '" alt="' + product.title + '" loading="lazy"></div>';
                }
                html += '<div><div class="predictive-search__result-title">' + product.title + '</div>';
                html += '<div class="predictive-search__result-price">' + product.price + '</div></div></a>';
              });
            }

            if (resources.articles && resources.articles.length > 0) {
              resources.articles.forEach(function (article) {
                html += '<a href="' + article.url + '" class="predictive-search__result">';
                html += '<div><div class="predictive-search__result-title">' + article.title + '</div>';
                html += '<div class="predictive-search__result-price">Article</div></div></a>';
              });
            }

            if (html) {
              searchResults.innerHTML = html;
              searchResults.classList.add('is-active');
            } else {
              searchResults.innerHTML = '<div class="predictive-search__result"><div>No results found</div></div>';
              searchResults.classList.add('is-active');
            }
          })
          .catch(function () {
            searchResults.classList.remove('is-active');
          });
      }, 300);
    });

    // Close on click outside
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-search-wrapper]')) {
        searchResults.classList.remove('is-active');
      }
    });

    // Close on Escape
    searchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        searchResults.classList.remove('is-active');
        this.blur();
      }
    });
  }

  /* ---------- Cookie Banner ---------- */
  var cookieBanner = document.getElementById('CookieBanner');
  if (cookieBanner) {
    // Check if consent already given
    var consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      setTimeout(function () {
        cookieBanner.classList.add('is-visible');
      }, 1500);
    }

    var acceptBtn = cookieBanner.querySelector('[data-cookie-accept]');
    var declineBtn = cookieBanner.querySelector('[data-cookie-decline]');

    if (acceptBtn) {
      acceptBtn.addEventListener('click', function () {
        localStorage.setItem('cookie_consent', 'accepted');
        cookieBanner.classList.remove('is-visible');
      });
    }

    if (declineBtn) {
      declineBtn.addEventListener('click', function () {
        localStorage.setItem('cookie_consent', 'declined');
        cookieBanner.classList.remove('is-visible');
      });
    }
  }

  /* ---------- Escape key closes drawers ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeMobileMenu();
      closeCartDrawer();
    }
  });

})();
